import store from "./store";
import Vue from "vue";
import axios from "axios";

export default {
  idTokenParsed: {},

  setIdTokenParsed(idTokenParsed) {
    this.idTokenParsed = idTokenParsed;
  },
  sortItems(items, event) {
    // const swapIndex = event.oldIndex > event.newIndex;
    let startIndex = 0; //swapIndex ? event.newIndex : event.oldIndex ;
    let endIndex = items.length - 1; //swapIndex ? event.oldIndex : event.newIndex ;
    let swapItems = [];
    let sortsIds = [];
    for (let i = startIndex; i <= endIndex; i++) {
      let id = items[i].id;
      sortsIds.push(id);
      swapItems.push({ id: id });
    }
    let sortedIds = sortsIds.sort((a, b) => {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    });

    for (let i = startIndex; i <= endIndex; i++) {
      swapItems[i]["sortOrder"] = sortedIds[i];
    }
    return swapItems;
  },
  isEmpty(str) {
    return !str || 0 === str.length;
  },
  getEmpty(str, defaultValue) {
    return this.isEmpty(str) ? defaultValue : str;
  },
  goNext(next, to) {
    if (!this.isEmpty(to.hash))
      next({ params: to.params, path: to.path, query: to.query });
    else next();
  },
  getBool(val) {
    return !!JSON.parse(String(val).toLowerCase());
  }
};
